export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14380.e75112b3.jpg";